module.exports = __webpack_public_path__ + "static/PrimitiveSix-75b0ef9686c2780e2f392dd5b1e50f52.png";